import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberHorizontal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronGrabberHorizontal"><Path fillRule="evenodd" clipRule="evenodd" d="M10.0608 8.00011L6.06077 12.0001L10.0608 16.0001L9.00011 17.0608L3.93945 12.0001L9.00011 6.93945L10.0608 8.00011ZM15.0001 6.93945L20.0608 12.0001L15.0001 17.0608L13.9395 16.0001L17.9395 12.0001L13.9395 8.00011L15.0001 6.93945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronGrabberHorizontal;
